import Splide from "@splidejs/splide";

export default class SplideFreeSlider {
  constructor(selector) {
    this.root = document.querySelector(selector);
    if (!this.root) return;

    this.bar = this.root.querySelector(".js-splide-bar");
    this.track = this.root.querySelector(".js-splide-track");
    this.thumb = this.root.querySelector(".js-tour-thumb");
    this.list = this.root.querySelector(".splide__list");
    this.splideTrack = this.root.querySelector(".splide__track");
    this.rafId = null;
    this.lastThumbX = -1;

    this.init();
  }

  init() {
    this.splide = new Splide(this.root, {
      arrows: false,
      pagination: false,
      drag: "free",
      snap: false,
      autoWidth: true,
      gap: 0,
      perPage: 1,
      perMove: 1,
      omitEnd: true,
      releaseWheel: true,
      noDrag: ".js-tour-thumb",
      flickPower: 120,
      speed: 400,
    });

    this.splide.mount();

    if (this.bar && this.track && this.thumb && this.list && this.splideTrack) {
      this.bindThumbEvents();
      this.bindResizeEvent();
      this.updateThumbPosition();
      this.startThumbLoop();
    }
  }

  bindResizeEvent() {
    window.addEventListener("resize", () => {
      this.updateThumbPosition(true);
    });
  }

  bindThumbEvents() {
    this.onThumbPointerDown = this.onThumbPointerDown.bind(this);
    this.onThumbClick = this.onThumbClick.bind(this);
    this.onBarClick = this.onBarClick.bind(this);

    this.thumb.addEventListener("pointerdown", this.onThumbPointerDown);
    this.thumb.addEventListener("click", this.onThumbClick);
    this.bar.addEventListener("click", this.onBarClick);
  }

  onThumbPointerDown(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  onThumbClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  onBarClick(e) {
    if (e.target.closest(".js-tour-thumb")) return;
    this.moveByPointer(e.clientX);
  }

  moveByPointer(clientX) {
    const barRect = this.bar.getBoundingClientRect();
    const thumbWidth = this.thumb.offsetWidth;
    const maxThumbX = Math.max(barRect.width - thumbWidth, 0);
    const maxSliderX = this.getMaxSliderX();

    let thumbX = clientX - barRect.left - thumbWidth / 2;
    thumbX = Math.max(0, Math.min(thumbX, maxThumbX));

    const ratio = maxThumbX === 0 ? 0 : thumbX / maxThumbX;
    const targetX = maxSliderX * ratio;

    this.splide.Components.Move.translate(-targetX);
    this.setThumbX(thumbX, true);
  }

  startThumbLoop() {
    const loop = () => {
      this.updateThumbPosition();
      this.rafId = requestAnimationFrame(loop);
    };

    this.rafId = requestAnimationFrame(loop);
  }

  updateThumbPosition(force = false) {
    const thumbWidth = this.thumb.offsetWidth;
    const maxThumbX = Math.max(this.bar.clientWidth - thumbWidth, 0);
    const maxSliderX = this.getMaxSliderX();
    const currentSliderX = this.getCurrentSliderX();
    const ratio = maxSliderX === 0 ? 0 : currentSliderX / maxSliderX;
    const thumbX = maxThumbX * ratio;

    this.setThumbX(thumbX, force);
  }

  setThumbX(x, force = false) {
    const roundedX = Math.round(x * 100) / 100;

    if (!force && roundedX === this.lastThumbX) return;

    this.thumb.style.transform = `translate3d(${roundedX}px,-50%,0)`;
    this.lastThumbX = roundedX;
  }

  getCurrentSliderX() {
    const position = this.splide.Components.Move.getPosition();
    return Math.max(Math.abs(position), 0);
  }

  getMaxSliderX() {
    return Math.max(this.list.scrollWidth - this.splideTrack.clientWidth, 0);
  }
}
